import React from "react";
import ImageProfile from "./Utilities/ImageProfile";

const tempImage = require("../assets/profilePic4.png");
const logoImage = require("../assets/Logo.png");
const giftBox = require("../assets/giftBox.png")
const menu = require("../assets/menu.png")

const catImages = {
    
    animals: require("../assets/outline/animals_outline.png"),
    art: require("../assets/outline/art_outline.png"),
    awesome: require("../assets/outline/awesome_outline.png"),
    boy: require("../assets/outline/boy_outline.png"),
    car: require("../assets/outline/cars_outline.png"),
    comics: require("../assets/outline/comics_outline.png"),
    food: require("../assets/outline/food_outline.png"),
    funny: require("../assets/outline/funny_outline.png"),
    gaming: require("../assets/outline/gaming_outline.png"),
    girl: require("../assets/outline/girl_outline.png"),
    home: require("../assets/outline/home_outline.png"),
    inspirational: require("../assets/outline/inspirational_outline.png"),
    lifestyle: require("../assets/outline/lifestyle_outline.png"),
    meme: require("../assets/outline/memes_outline.png"),
    music: require("../assets/outline/music_outline.png"),
    nsfw: require("../assets/outline/nsfw_outline.png"),
    science: require("../assets/outline/science_outline.png"),
    sports: require("../assets/outline/sports_outline.png"),
    stories: require("../assets/outline/stories_outline.png"),
    travel: require("../assets/outline/travel_outline.png"),
    tv: require("../assets/outline/tv_outline.png"),
    wtf: require("../assets/outline/wtf_outline.png"),
}

const temporaryTags = [
    {hashtag: "me",},
    {hashtag: "love",},
    {hashtag: "happy",},
    {hashtag: "selfie",},
    {hashtag: "art",},
    {hashtag: "photography",},
    {hashtag: "travel",},
    {hashtag: "cute",},
    {hashtag: "funny",},
    {hashtag: "wtf",},
    {hashtag: "awesome",},
    {hashtag: "food",},
    {hashtag: "gaming",},
    {hashtag: "lifestyle",},
    {hashtag: "like",},
    {hashtag: "photooftheday",},
    {hashtag: "fitness",},
    {hashtag: "amazing",},
    {hashtag: "style",},
]

const Aux = {
    handleError: function(error){
        console.error(error)
    },
    handleLog: function(log){
        console.log(log)
    },
    formatTextNewLine: function(text){
        try{
            //console.log(text);
            return text.replace(/[\r\n|\r|\n]+/g,'\n');
            //console.log(newText);

        }catch(error){
            this.handleError(error)
        }
    },
    showAvatar: function (height, avatar, name) {
        // let letter = name.charAt(0)
        return (
             <ImageProfile height={height} avatar={avatar} name={name || "Unknown"}/>
        )
           
        /* if (avatar) {
            return (
                <img onLoad={() => console.log("loaded")}style={{ height: height, width: height, borderRadius: 50, objectFit:"cover", }}
                    src={avatar ? avatar : this.TemporaryImage} alt="avatar"  >
                </img>
            )
        } else {
            return (
                <div style={{display:"flex", height: height, width: height, borderRadius: 50, backgroundColor: "#ccc", justifyContent: "center" }}>
                    <h1 style={{ justifyContent: "center", alignSelf: "center", color: "white", fontWeight:"bold", fontSize:height/2, marginBottom:2 }}>{letter.toUpperCase()}</h1>
                </div>
            )
        } */
    },
    showHidden: function (height){
        return (
            <img style={{ height: height, width: height, borderRadius: 50, objectFit:"cover", }}
                src={this.TemporaryImage} alt="Incognito Avatar"  >
            </img>
        )
    },
    showCollectable: function (height, collectableImg, ){
        if (collectableImg) {
            return (
                <img style={{ height: height, width: height, borderRadius: 10, objectFit:"cover", }}
                    src={collectableImg ? collectableImg : this.TemporaryCollectable} alt="collectable"  >
                </img>
            )
        } else {
            return (
                <div style={{display:"flex", height: height, width: height, borderRadius: 10, backgroundColor: "#ccc", justifyContent: "center" }}>
                    <h1 style={{ justifyContent: "center", alignSelf: "center", color: "white", fontWeight:"bold", fontSize:height/2, marginBottom:2 }}>Hidden</h1>
                </div>
            )
        }
    },
    LIMIT: 20,
    TemporaryImage: tempImage,
    TemporaryCollectable: tempImage,
    LogoImage: logoImage,
    GiftBox: giftBox,
    menuIcon: menu,
    temporaryTags: temporaryTags,
    CategoryImages: catImages,

}

export default Aux